import PropTypes from 'prop-types';
import { SelectField, DatePicker, MenuItem } from 'material-ui';
import React from 'react';
import config from 'cfg';
import req from 'superagent';
import moment from 'moment';
import _ from 'lodash';

const TOURNAMENTS = [46, 85, 239, 47, 87, 54, 55, 42, 73, 57, 53, 71, 61, 67, 59, 135, 77, 50, 48, 108, 109, 146];

const getInitialDate = (date, eventId) => {
    if (eventId) {
        return date ? new Date(date) : null;
    }
    return date ? new Date(date) : new Date();
};

class EventByDatePicker extends React.Component {
    static propTypes = {
        eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func.isRequired,
        date: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    };

    static defaultProps = {
        sportId: 1
    };

    constructor(props, context) {
        super(props, context);
        const { date, eventId } = props;
        this.state = {
            date: getInitialDate(date, eventId),
            eventId: eventId ? Number(eventId) : null,
            events: []
        };
    }

    componentDidMount() {
        const { eventId } = this.props;
        if (eventId) {
            req.get(`${config.apis.ss2}/events/${eventId}`).then(res => {
                if (res.body) {
                    if (this.props.eventId === eventId) {
                        const { startDate } = res.body;
                        this.handleDateChange(null, new Date(startDate), true);
                    }
                }
            });
        }
        if (this.state.date) {
            this.handleDateChange(null, this.state.date);
        }
    }

    handleDateChange = (_, value, silent = false) => {
        const date = moment(value);
        const from = date.format('YYYY-MM-DD');
        const to = date.add(1, 'day').format('YYYY-MM-DD');
        const { sportId } = this.props;
        this.setState({ date: value });
        if (!silent) {
            this.props.onChange('date', from);
        }
        const baseUrl = `${config.apis.ss2}/events-v2?fromDate=${from}&toDate=${to}&sportId=${sportId}`;
        const url = TOURNAMENTS.reduce((sum, val) => `${sum}&ttId[]=${val}`, baseUrl);
        return req.get(url).then(res => {
            this.setState({ events: res.body.events });
        });
    };

    renderOption(e) {
        // const text = `${moment(e.startDate).utc().format('DD.MM')} ${e.homeShortName}-${e.awayShortName}`;
        const text = `${moment(e.startDate)
            .utc()
            .format('HH:mm')} ${e.homeName} - ${e.awayName}`;
        const secondaryText = e.statusType === 'finished' ? `${e.score.home}-${e.score.away}` : null;
        return (
            <MenuItem
                style={{ minWidth: '400px' }}
                key={e.eventId}
                value={e.eventId}
                primaryText={text}
                secondaryText={secondaryText}
            />
        );
    }

    handleEventChange = (e, key, val) => {
        this.setState({ eventId: val }, () => {
            this.props.onChange('eventId', val);
        });
    };

    render() {
        const eventsOptions = this.state.events;
        const options = _.toPairs(_.groupBy(eventsOptions, event => event.tournamentName));
        return (
            <div>
                <DatePicker
                    hintText="Choose date"
                    style={{ overflow: 'hidden', width: '100%' }}
                    value={this.state.date}
                    container="dialog"
                    autoOk
                    onChange={this.handleDateChange}
                />
                <SelectField
                    autoWidth
                    floatingLabelText="Events"
                    style={{ overflow: 'hidden', width: '100%' }}
                    value={this.state.eventId}
                    disabled={!this.state.date}
                    onChange={this.handleEventChange}
                >
                    {options.map(pair => [
                        <div
                            style={{
                                padding: '5px 24px',
                                fontSize: '12px',
                                backgroundColor: '#eaeaea'
                            }}
                            key={pair[0]}
                        >
                            {pair[0]}
                        </div>,
                        pair[1].map(this.renderOption)
                    ])}
                </SelectField>
            </div>
        );
    }
}

export default EventByDatePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/EventByDatePicker.js
 **/